import React from 'react';
import { BlogArticleTemplate } from '../../components/blog/BlogArticleTemplate';
import { nhsVsPrivateArticle } from '../../data/blog/nhsVsPrivateArticle';
export function NhsVsPrivateArticle() {
  return <BlogArticleTemplate article={nhsVsPrivateArticle} data-id="element-805" data-mp="2192az9ir64ze" />;
}